import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
Vue.use(Vuetify, {
  options: {
    customProperties: true
  }
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.deepPurple.accent2,
        secondary: colors.grey.darken1,
        accent: colors.deepPurple.accent2
      },
      dark: {
        primary: colors.blueGrey.darken1,
        secondary: colors.grey.darken1,
        accent: colors.blueGrey.darken1
      }
    },
    dark: false
  }
});

export type VuetifyForm = Vue & {
  validate: () => void;
  resetValidation: () => void;
};

export type VuetifyTextInput = Vue & {
  blur: () => void;
};
